import React from 'react'
import styled from 'styled-components'
import { Link as RouterLink } from 'react-router-dom'

import { fonts, palette, mediaQueries } from '../../styles/variables'

export const HighlightText = styled.span((props) => ({
  fontFamily: props.bold ? fonts.primaryBold : fonts.primary,
  fontWeight: props.bold ? 700 : 400,
  color: props.color ? props.color : palette.orange,
  textDecoration: props.underline ? 'underline' : 'none',
  cursor: props.underline ? 'pointer' : 'inherit',
  marginRight: '0.5em',
}))

export const Text = styled.div((props) => ({
  display: props.display || 'display',
  color: props.color || palette.darkGray,
  fontSize: props.fontSize || '14px',
  fontFamily: props.fontFamily || fonts.primary,
  fontWeight: props.fontWeight || 'normal',
  fontStyle: props.fontStyle || 'normal',
  margin: props.margin || '0px',
  padding: props.padding || '0px',
  lineHeight: props.lineHeight || 'normal',
  letterSpacing: props.letterSpacing || 'inherit',
  whiteSpace: props.whiteSpace || 'pre-wrap',
  wordBreak: props.wordBreak || 'break-word',
  textAlign: props.textAlign || 'left',
  textDecoration: props.textDecoration || 'none',
  textTransform: props.textTransform || 'none',
  cursor: props.cursor || 'auto',
  transform: props.transform || 'none',
  transition: props.transition || 'none',
  background: props.background || 'none',
  textWrap: props.textWrap || 'initial',
  overflow: props.overflow || 'initial',
  textOverflow: props.textOverflow || 'initial',
  position: props.position || 'initial',
  zIndex: props.zIndex || 'initial',
  '& b': {
    color: props.boldColor || palette.orange,
    backgroundColor: props.boldBgColor || 'none',
    borderRadius: props.boldBorderRadius || 'none',
    fontFamily: props.boldFontFamily || fonts.primaryMedium,
    fontSize: props.boldFontSize || props.fontSize || '14px',
    fontWeight: props.boldFontWeight || 'normal',
    padding: props.boldPadding || '0px',
    textDecoration: props.textDecoration || 'none',
    whiteSpace: props.boldWhiteSpace || 'pre-wrap',
  },
  '& a': {
    cursor: 'pointer',
    color: props.linkColor || palette.orange,
    textDecoration: 'underline',
  },
  [mediaQueries.mobile]: {
    whiteSpace: props.mobileWhiteSpace || 'pre-wrap',
    fontSize: props.mobileFontSize || props.fontSize || '14px',
    lineHeight: props.mobileLineHeight || props.lineHeight || 'normal',
    margin: props.mobileMargin || props.margin || '0px',
    padding: props.mobilePadding || props.padding || '0px',
    textAlign: props.mobileTextAlign || props.textAlign || 'left',
    color: props.mobileColor || props.color || palette.darkGray,
    '& b': {
      fontSize:
        props.mobileBoldFontSize ||
        props.boldFontSize ||
        props.fontSize ||
        '14px',
    },
  },
  ...(props.customMediaQuery && {
    [`@media only screen and (max-width: ${props.customMediaQuery.queryWidth})`]:
      {
        width: props.customMediaQuery.width,
      },
  }),
}))

export const LinkText = styled.a((props) => ({
  fontFamily: props.fontFamily || fonts.primaryLight,
  color: props.disabled ? palette.gray : props.color || palette.orange,
  fontSize: props.fontSize || 'inherit',
  textDecoration: props.textDecoration || 'none',
  lineHeight: props.lineHeight || 'inherit',
  cursor: 'pointer',
  pointerEvents: props.disabled ? 'none' : 'all',
  [mediaQueries.mobile]: {
    fontSize: props.mobileFontSize || props.fontSize || '14px',
  },
}))

export const HeadingsCapsH4 = styled(Text)({
  fontSize: '12px',
  lineHeight: '12px',
  letterSpacing: '0.08em',
  fontFamily: fonts.primaryBold,
  textTransform: 'uppercase',
  display: 'flex',
  alignItems: 'center',
})

export const Link = ({ type, to, children, ...props }) => {
  if (type === 'direct') {
    return (
      <a href={to} {...props}>
        {children}
      </a>
    )
  }
  return (
    <RouterLink to={to} {...props}>
      {children}
    </RouterLink>
  )
}

export const ButtonLink = styled.div(() => ({
  cursor: 'pointer',
}))

export const Heading1A = styled(Text)({
  fontSize: '24px',
  lineHeight: '24px',
  fontFamily: fonts.primaryMedium,
  letterSpacing: '0px',
  textTransform: 'uppercase',
})

export const Heading2A = styled(Text)(() => ({
  fontSize: '16px',
  lineHeight: '16px',
  fontFamily: fonts.primaryMedium,
  letterSpacing: '0px',
  textTransform: 'uppercase',
}))

export const Heading3A = styled(Text)(() => ({
  fontSize: '14px',
  lineHeight: '14px',
  fontFamily: fonts.primaryMedium,
  letterSpacing: '0px',
  textTransform: 'uppercase',
}))

export const Label = styled(Text)({
  fontSize: '14px',
  lineHeight: '14px',
  fontFamily: fonts.primaryBook,
  marginBottom: '12px',
})
